module.exports = __webpack_public_path__ + "img/ESQUINERO.49ed70dc.webp";